module.exports = __webpack_public_path__ + "img/anthony.156f9205.png";